import React from 'react'
import { Grid } from 'semantic-ui-react'

import MainInfo from '../common/MainInfo'
import { SymptomCheckerIcon } from 'components/Icons'

import styles from './styles'

const SYMPTOM_CHECKER_URL = 'https://symptoms.webmd.com/'

export const SymptomChecker = () => {
  return (
    <Grid>
      <Grid.Column mobile={12} tablet={13} computer={13} largeScreen={13} widescreen={13} style={styles.leftContainer}>
        <MainInfo
          icon={<SymptomCheckerIcon />}
          iconName={'user md'}
          title={'Symptom Checker'}
          text={'Identify possible conditions and treatment related to your symptoms.'}
        />
      </Grid.Column>
      <Grid.Column
        mobile={4}
        tablet={3}
        computer={3}
        largeScreen={3}
        widescreen={3}
        style={styles.rightContainer}
      >
        <span style={styles.link}>
          <a href={SYMPTOM_CHECKER_URL} target="_blank" rel="noopener noreferrer">
            View &gt;
          </a>
        </span>
      </Grid.Column>
    </Grid>
  )
}
